import { Component, Input, Output, EventEmitter, ViewChild, OnChanges, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { isNil } from 'lodash';
import { TreeviewI18n, TreeviewItem, TreeviewConfig, DropdownTreeviewComponent, TreeviewHelper } from 'ngx-treeview';
import { DropdownTreeviewSelectI18n } from './dropdown-treeview-select-i18n';

@Component({
  selector: 'ngx-dropdown-treeview-select',
  templateUrl: './dropdown-treeview-select.component.html',
  styleUrls: [
    './dropdown-treeview-select.component.scss'
  ],
  providers: [
    { provide: TreeviewI18n, useClass: DropdownTreeviewSelectI18n }
  ]
})
export class DropdownTreeviewSelectComponent implements OnChanges {
  @Input() config: TreeviewConfig;
  @Input() items: TreeviewItem[];
  @Input() value: any;
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<any>();
  @ViewChild(DropdownTreeviewComponent, { static: false }) dropdownTreeviewComponent: DropdownTreeviewComponent;
  filterText: string;
  dllNgxddTreeView;
  selectedItem;
  private dropdownTreeviewSelectI18n: DropdownTreeviewSelectI18n;

  constructor(
    public i18n: TreeviewI18n
  ) {
    this.config = TreeviewConfig.create({
      hasAllCheckBox: false,
      hasCollapseExpand: false,
      hasFilter: true,
      maxHeight: 500
    });
    this.dropdownTreeviewSelectI18n = i18n as DropdownTreeviewSelectI18n;
  }

  ngOnChanges(): void {
    this.updateSelectedItem();
  }

  @ViewChild("ngxddTreeView") private ngxddTreeView;
  ngAfterViewInit() {
    this.dllNgxddTreeView = this.ngxddTreeView;
    this.selectItem(this.selectedItem);
  }


  select(item: TreeviewItem): void {
    if (!item.children) {
      this.selectItem(item);
    }
  }

  private updateSelectedItem(): void {
    if (!isNil(this.items)) {
      const selectedItem = TreeviewHelper.findItemInList(this.items, this.value);
      this.selectItem(selectedItem);
    }
  }

  private selectItem(item: TreeviewItem): void {
    this.selectedItem = item;
    var btn = this.ngxddTreeView?.nativeElement.children[0].children[0].children[0];
    if (this.dropdownTreeviewSelectI18n.selectedItem !== item) {
      this.dropdownTreeviewSelectI18n.selectedItem = item;
      if (this.dropdownTreeviewComponent) {
        this.dropdownTreeviewComponent.onSelectedChange([item]);
      }

      if (item) {
        if (this.value !== item.value) {
          this.value = item.value;
          this.valueChange.emit(item.value);
        }
      }
      if (this.ngxddTreeView?.nativeElement.children[0].children[0].children[0].attributes["aria-expanded"].value === "true") {
        btn.click();
      }
      // this.ngxddTreeView.nativeElement.children[0].children[0].classList.remove("show");
      // this.ngxddTreeView.nativeElement.children[0].children[0].children[1].classList.remove("show");
      // this.ngxddTreeView.nativeElement.children[0].children[0].children[0].attributes["aria-expanded"].value = "false";

      //aria-expanded
    }
    if (btn) {
      btn.disabled = this.disabled;
    }
  }
}
